
$(document).ready(function() {
    if ($('body').data('router-name') !== 'translated-product-index') {
        return;
    }

    var editors = {};
    var sliders = {};

    // galerie produktu
    var initializeSlider = function(){
        $(".product-thumbnail").each(function(){
            var name = $(this).find('.product-thumbnail-carousel').attr('id');
            if (typeof sliders[name] === 'undefined') {
                var self = $(this);

                var $slider = $(this).find('.product-thumbnail-items').lightSlider({
                    item: 1,
                    controls: false,
                    pager: false,
                    loop: true,
                    adaptiveHeight: true,
                    onBeforeSlide: function(el) {
                        self.find('.product-thumbnail-caption-indicator').text(el.getCurrentSlideCount());
                        var $img = el.find('.lslide').eq(el.getCurrentSlideCount()-1).find('img');
                        $img.attr('src', $img.attr('data-src'));
                    },
                    onSliderLoad: function() {
                        self.find('.product-thumbnail-carousel').removeClass('is-loading');
                    }
                });

                $(this).delegate('.carousel-control-next', 'click', function(e){
                    e.preventDefault();
                    $slider.goToNextSlide();
                });

                $(this).delegate('.carousel-control-prev', 'click', function(e){
                    e.preventDefault();
                    $slider.goToPrevSlide();
                });

                sliders[name] = $slider;

                var lightbox = $(this).find('.product-thumbnail-item').not('.clone').simpleLightbox({
                    sourceAttr: 'data-img',
                    alertError: false,
                });

                var isDragging = false;
                $(this).find('.product-thumbnail-item').not('.clone').mousedown(function() {
                    isDragging = false;
                }).mousemove(function() {
                    isDragging = true;
                }).mouseup(function(e) {
                    var wasDragging = isDragging;
                    isDragging = false;

                    if (!wasDragging && e.button !== 2) {
                        lightbox.open($(this));
                    }
                });
            }
        });

        activeLazyload();
    };

    initializeSlider();


    var editors = window.initCkEditor();

    $('[data-form-action-url] button').on('click', function(ev) {
        ev.preventDefault();

        var $button = $(this);
        var btnName = $button.prop('name');
        var $form = $button.closest('form');
        var url = $form.data('form-action-url');

        window.copyCKEditorToTextArea(editors);
        var data = $form.serialize();
        data = data + '&btn=' + btnName;
        $.post({
            url: url,
            data: data,
            success: function(data) {
                if (data.message) {
                    window.alert(data.message);
                }
                if (btnName === 'checked') {
                    $button.remove();
                }
            }
        });
    });


    $(function() {
        var $btn = $('[data-translated-product-url-save]');
        if (!$btn.length) {
            return;
        }

        var loadData = function() {
            $btn.each(function(i, el) {
                var $content = $(el).closest('[data-translated-product-url-content]');
                var $input = $content.find('[data-translated-product-url-input]');

                $(el).addClass('disabled');
                if ($input.val() !== $input.data('default-value')) {
                    $(el).removeClass('disabled');
                }
            });
        };

        $('[data-translated-product-url-input]').on('keyup', function() {
            loadData();
        });
        loadData();

        $btn.on('click', function() {
            var $content = $(this).closest('[data-translated-product-url-content]');
            var $input = $content.find('[data-translated-product-url-input]');
            var value = $input.val();

            if ($input.val() !== $input.data('default-value')) {
                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    method: 'POST',
                    url: '/admin/translated-product/change-url/',
                    data: {
                        url: value,
                        default_url: $input.data('default-value'),
                        product_langs: $input.data('translated-product-url-input'),
                        attribute: $input.data('translated-product-url-attribute'),
                    },
                    success: function(response) {
                        if (response.status === 'success') {
                            var $link = $content.find('[data-translated-product-url-link]');
                            $link.prop('href', value);
                            $link.find('img').prop('src', value);
                            $input.data('default-value', value);
                            loadData();

                            window.alert(response.message);
                        }
                        else if (response.status === 'error') {
                            window.alert(response.message);
                        }
                    },
                    error: function() {
                        window.alert('Response error');
                    }
                });
            }
        });



    });
});
